/**
 * Password validation utilities
 */

const MIN_PASSWORD_LENGTH = 6

/**
 * Validates password meets minimum requirements
 * @param password - Password to validate
 * @returns Object with isValid flag and error message if invalid
 */
export const validatePassword = (password: string): { isValid: boolean; error?: string } => {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return {
      isValid: false,
      error: "login.passwordTooShort",
    }
  }
  return { isValid: true }
}

/**
 * Validates password confirmation matches password
 * @param password - Original password
 * @param confirmPassword - Confirmation password
 * @returns Object with isValid flag and error message if invalid
 */
export const validatePasswordConfirmation = (
  password: string,
  confirmPassword: string
): { isValid: boolean; error?: string } => {
  if (password !== confirmPassword) {
    return {
      isValid: false,
      error: "login.passwordsDoNotMatch",
    }
  }
  return { isValid: true }
}

/**
 * Validates password and confirmation together
 * @param password - Password to validate
 * @param confirmPassword - Confirmation password
 * @returns Object with isValid flag and first error message if invalid
 */
export const validatePasswordForm = (
  password: string,
  confirmPassword: string
): { isValid: boolean; error?: string } => {
  const passwordValidation = validatePassword(password)
  if (!passwordValidation.isValid) {
    return passwordValidation
  }

  const confirmationValidation = validatePasswordConfirmation(password, confirmPassword)
  if (!confirmationValidation.isValid) {
    return confirmationValidation
  }

  return { isValid: true }
}

